import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashTransferSearchRequest from "../CashTransferSearchRequest";
import ModelProxyClass from "./ModelProxyClass";
import ResultParameter from "../ResultParameter";


/**
 * @class CashTransferSearchRequestBase
 * @extends ModelBaseClass
 * @property {number} involvingCashAccountId (int64) regardless if its TO the cashAccount or FROM the cashAccount, filter by any CashTransfers that involved the specified CashAccountId
 * @property {number} involvingFillAtLocationId (int64) locationId of fills
 * @property {Date} filterByDateRangeStart (date only) filter by the date of the transfer
 * @property {Date} filterByDateRangeEnd (date only) filter by the date of the transfer
 * @property {ResultParameter} resultParameter [DateTransferred]
 */
class CashTransferSearchRequestBase extends ModelBaseClass {
	/**
	 * regardless if its TO the cashAccount or FROM the cashAccount, filter by any CashTransfers that involved the specified CashAccountId
	 * @type {number} involvingCashAccountId (int64)
	 */
	involvingCashAccountId;
	/**
	 * locationId of fills
	 * @type {number} involvingFillAtLocationId (int64)
	 */
	involvingFillAtLocationId;
	/**
	 * filter by the date of the transfer
	 * @type {Date} filterByDateRangeStart (date only)
	 */
	filterByDateRangeStart;
	/**
	 * filter by the date of the transfer
	 * @type {Date} filterByDateRangeEnd (date only)
	 */
	filterByDateRangeEnd;
	/**
	 * [DateTransferred]
	 * @type {ResultParameter} resultParameter
	 */
	resultParameter;

	/**
	 * Instantiates a new instance of CashTransferSearchRequest based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashTransferSearchRequest}
	 */
	static create(genericObject) {
		const newCashTransferSearchRequest = new CashTransferSearchRequest();
		newCashTransferSearchRequest.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashTransferSearchRequest;
	}

	/**
	 * Instantiates a new array of CashTransferSearchRequest based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashTransferSearchRequest]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashTransferSearchRequestArray = [];
		genericArray.forEach(genericObject => {
			newCashTransferSearchRequestArray.push(CashTransferSearchRequest.create(genericObject));
		});
		return newCashTransferSearchRequestArray;
	}
}

/**
 * @type {string} OrderByDateTransferred
 */
CashTransferSearchRequestBase.OrderByDateTransferred = 'datetransferred';

const _modelDefinition = [
	ModelBaseClass.createModelProperty('involvingCashAccountId', 'integer'),
	ModelBaseClass.createModelProperty('involvingFillAtLocationId', 'integer'),
	ModelBaseClass.createModelProperty('filterByDateRangeStart', 'datetime'),
	ModelBaseClass.createModelProperty('filterByDateRangeEnd', 'datetime'),
	ModelBaseClass.createModelProperty('resultParameter', 'ResultParameter'),
];

export default CashTransferSearchRequestBase;
